import { render, staticRenderFns } from "./IconButton.vue?vue&type=template&id=c6393ce2&scoped=true&"
import script from "./IconButton.vue?vue&type=script&lang=js&"
export * from "./IconButton.vue?vue&type=script&lang=js&"
import style0 from "./IconButton.vue?vue&type=style&index=0&id=c6393ce2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6393ce2",
  null
  
)

export default component.exports